const tenant = {
  state: {
    id: localStorage.getItem('tenantId') || '' // 从localStorage读取，不存在则为空
  },

  mutations: {
    SET_ID: (state, id) => {
      if (!id) {
        localStorage.removeItem('tenantId') // 清除空值
      } else {
        localStorage.setItem('tenantId', id)
      }
      state.id = id
    }
  },

  actions: {
    setTenantId: ({ commit, state }, id) => {
      if (!id && state.id === 'OpenAuthDBContext') {
        // 保留超级管理员的默认租户ID
        return
      }
      commit('SET_ID', id)
    },
  },

  getters: {
    tenantid: state => state.id || 'OpenAuthDBContext' // 保持向后兼容
  }
}

export default tenant
